<template>
  <div id="gallery" class="gallery-wrap style1 pb-100">
    <div class="container">
      <div class="row">
        <div class="col-xl-7 col-lg-9">
          <div class="section-title style1 mb-40">
            <span>Gallery Exhibition</span>
            <h2>
              Discover Your Dental Repair &amp; Recovery Works For Our Medical
              Clinic
            </h2>
          </div>
        </div>
      </div>

      <Carousel
        :autoplay="5000"
        :wrap-around="true"
        :breakpoints="breakpoints"
        pause-autoplay-on-hover
        class="gallery-slider-one"
      >
        <Slide v-for="gallery in galleries" :key="gallery.id">
          <div class="gallery-card style1">
            <div class="gallery-img">
              <img :src="gallery.image" alt="Image" />
              <div class="gallery-info">
                <router-link class="gallery-icon" to="/gallery-details">
                  <i class="ri-add-line"></i>
                </router-link>

                <h3>
                  <router-link to="/gallery-details">
                    {{ gallery.title }}
                  </router-link>
                </h3>
              </div>
            </div>
          </div>
        </Slide>

        <template #addons>
          <Pagination />
        </template>
      </Carousel>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { Carousel, Slide, Pagination } from "vue3-carousel";

export default defineComponent({
  name: "GalleryExhibition",
  components: {
    Carousel,
    Slide,
    Pagination,
  },
  data: () => ({
    settings: {
      itemsToShow: 1,
      snapAlign: "center",
    },
    galleries: [
      {
        id: 1,
        image: require("../../assets/images/gallery/gallery-1.jpg"),
        title: "Free Dental Checkup For Adult",
      },
      {
        id: 2,
        image: require("../../assets/images/gallery/gallery-2.jpg"),
        title: "Best Treatment For A Healthy Life",
      },
      {
        id: 3,
        image: require("../../assets/images/gallery/gallery-3.jpg"),
        title: "Regular Teeth Checkup For Child",
      },
      {
        id: 4,
        image: require("../../assets/images/gallery/gallery-4.jpg"),
        title: "Root Canel Without Any Surgery",
      },
      {
        id: 5,
        image: require("../../assets/images/gallery/gallery-5.jpg"),
        title: "Healthy Teeth Transplant At Low Cost",
      },
    ],
    breakpoints: {
      0: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      768: {
        itemsToShow: 2,
        snapAlign: "start",
      },
      1200: {
        itemsToShow: 3,
        snapAlign: "center",
      },
    },
  }),
});
</script>